var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-width":"1300px","padding":"50px 8%"}},[_c('p',{staticStyle:{"text-align":"center","font-size":"30px"}},[_vm._v("合作机构")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","font-size":"15px"}},[_vm._v("Cooperation agency")]),_vm._v(" "),_c('agencylist',{staticStyle:{"margin":"50px 0"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00148764","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/v2/index/agencylist/index.vue
// module id = null
// module chunks = 